import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Physiotherapists from './components/Physiotherapists/Physiotherapists';
import Testimonials from './components/Testimonials/Testimonials';
import BookingForm from './components/BookingForm/BookingForm';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <Physiotherapists />
      <Testimonials />
      <BookingForm />
      <Footer />
    </div>
  );
}

export default App;